module.exports = __webpack_public_path__ + "img/brand-14.b8a77db9.png";